import { FieldType } from '@common/dto/field/type';
import { DatasheetFieldComponentGetDto } from '@common/dto/datasheet/field-component/get-dto';

export const NON_TAB_FIELD_TYPES = new Set<FieldType>([
  FieldType.table,
  FieldType.computed,
  FieldType.summary,
  FieldType.tableSummary,
]);

export function isFieldTypeTabNavigable(
  fieldType: FieldType | number,
  isSystemField: boolean,
): boolean {
  if (isSystemField) return false;
  return !NON_TAB_FIELD_TYPES.has(fieldType as FieldType);
}

export function isTabNavigationTarget(original: DatasheetFieldComponentGetDto): boolean {
  if (original.editable === false) return false;
  const field = (original as any).field as Record<string, any> | undefined;
  if (!field) return false;
  const isSystemField =
    field.system === true || field.systemField === true || field.fieldtype?.systemType === true;
  const fieldType: number = field.fieldtype?.typeid ?? field.type ?? field.rawFieldType;
  return isFieldTypeTabNavigable(fieldType, isSystemField);
}
